export { default as EmailDisplay } from './EmailDisplay';
export type { EmailDisplayProps } from './EmailDisplay';
